import { render } from "./AddBescStep1Page.vue?vue&type=template&id=64a42a1a&ts=true"
import script from "./AddBescStep1Page.vue?vue&type=script&lang=ts"
export * from "./AddBescStep1Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__